// IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
// Ссылочное поле (AttrLink с relation_segment) хранит id элемента сегмента, а не его название.
// Корень дефекта (dev02, 1fxa_001 → Параметри → «Процесна модель», doc.params.process_model_override): форма параметров —
// AttrTabGrid, колонка значений AttrMulti с customValueWarning (common_modules/attrs.py attrs_value 'AttrTabGrid-value').
// AttrGrid.cellEditEnding2 при несопоставленном тексте шёл в ветку customValueWarning: «if (!V.value) V.value = newVal» —
// пустое поле получало ТЕКСТ редактора (название «PM-2026 10 01 · 2026-10-28 (усічена копія)»), relation_attr_set писал его
// в запись, и select уходил с названием. Словарь PROCESS-MODEL — 'by_ids' (только id со страницы), копий ПМ в нём нет.
// Здесь — чистые функции: строгое сопоставление текста с пунктом словаря (id / название / код / названия на других языках),
// только однозначное; плюс выключатели. Подключение: AttrGrid (cellEditEnding2, choiceFinish, relation_attr_set) и
// mainStore.prepare_AttrMulti (старые записи с названием вместо id).

// выключатели: fe.data.linkTextToId — правка пишет id (несопоставленный текст не пишется); fe.data.linkLegacyTitleToId —
// название в старой записи при чтении сопоставляется с id. Оба по умолчанию вкл
export function linkTextToId_on(store) {
    try { return store?.setting?.('fe.data.linkTextToId', true) !== false } catch (e) { return true }
}
export function linkLegacyTitleToId_on(store) {
    try { return store?.setting?.('fe.data.linkLegacyTitleToId', true) !== false } catch (e) { return true }
}

// формула / выражение (=…, #…) — не название, не сопоставляется
export function linkIsFormula(text) {
    const s = String(text ?? '').trim()
    return s.startsWith('=') || s.startsWith('#')
}

// строка-поле со ссылкой на сегмент (форма AttrTabGrid: V — описание поля; грид: колонка AttrLink)
export function linkIsRef(V) {
    return !!(V && V.relation_segment && (!V.attr_type || V.attr_type === 'AttrLink'))
}

function names(item) {
    const out = []
    if (item?.title != null && item.title !== '') out.push(String(item.title))
    if (item?.code != null && item.code !== '') out.push(String(item.code))
    if (Array.isArray(item?.titles_alt)) for (const v of item.titles_alt) if (v != null && v !== '') out.push(String(v))
    return out
}

// однозначный пункт по тексту: точный id; иначе точное название / код / название на другом языке; иначе то же без учёта
// регистра и крайних пробелов. Несколько РАЗНЫХ id на одном уровне — null (неоднозначно, не угадываем)
export function linkResolveText(items, text) {
    if (!Array.isArray(items) || text == null) return null
    const raw = String(text)
    const s = raw.trim()
    if (!s || linkIsFormula(s)) return null
    const byId = items.find(it => it && it.id != null && (String(it.id) === raw || String(it.id) === s))
    if (byId) return { id: byId.id, title: byId.title ?? byId.id }
    const pick = (pred) => {
        const found = new Map()
        for (const it of items) {
            if (!it || it.id == null) continue
            if (names(it).some(pred)) found.set(String(it.id), it)
            if (found.size > 1) return { ambiguous: true }
        }
        const it = found.size === 1 ? [...found.values()][0] : null
        return it ? { id: it.id, title: it.title ?? it.id } : null
    }
    let r = pick(n => n === raw || n === s)
    if (r) return r.ambiguous ? null : r
    const low = s.toLowerCase()
    r = pick(n => n.trim().toLowerCase() === low)
    return r && !r.ambiguous ? r : null
}

// значение ссылки, которого нет среди id словаря, но которое однозначно совпало с названием пункта (старая запись) —
// { id, title }; иначе null. itemsSource — объект словаря сегмента стора ({ data, ids })
export function linkLegacyResolve(itemsSource, value) {
    if (value == null || typeof value !== 'string' || !value.trim() || linkIsFormula(value)) return null
    if (!itemsSource || !Array.isArray(itemsSource.data)) return null
    if (itemsSource.ids && Object.prototype.hasOwnProperty.call(itemsSource.ids, value)) return null
    const r = linkResolveText(itemsSource.data, value)
    return r && String(r.id) !== value ? r : null
}
